declare var $: any;
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PreguntaService } from 'src/app/services/pregunta.service';
import { Location } from '@angular/common';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { helpService } from '../../services/help.service';
import { TokenAdmService } from 'src/app/services/token-adm.service';
import { Observable } from 'rxjs';
import { ElementoBusquedaService } from 'src/app/services/elemento-busqueda.service';
import { MsalService } from '@azure/msal-angular';
import { SafeHtml } from '@angular/platform-browser';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-respuesta',
  templateUrl: './respuesta.component.html',
  styleUrls: ['./respuesta.component.css'],
})
export class RespuestaComponent implements OnInit {
  id: number;
  pregunta: any;
  ruta: string;
  loading: boolean = false;
  burbujaId: string;
  respForm: FormGroup;
  isAdmin: boolean;
  isContribuidor: boolean;
  hashtags: string = '';
  respuestaId: number = 0;
  paginaBuscador: number = 1;
  formuHash: FormGroup;
  editarHash: boolean = false;
  verBtnEditarHash: boolean = true;
  textoHashInvalido: string;
  tempoHastag: string;
  respFormPub: FormGroup;
  muestraFeed: boolean = false;
  html: SafeHtml;
  editar: boolean = false;

  constructor(
    private actRouter: ActivatedRoute,
    private router: Router,
    private preguntaService: PreguntaService,
    private location: Location,
    private fb: FormBuilder,
    private apiRest: helpService,
    private tokenService: TokenAdmService,
    private fbHash: FormBuilder,
    private elementoService: ElementoBusquedaService,
    private authService: MsalService,
    private domS: DomSanitizer
  ) {
    $(document).ready(function () {
      var textOriginal;
      $('#edit').on('click', function () {
        if ($('#edit').attr('tipo') == 'editar') {
          $('.click2edit').summernote({
            focus: true,
            lang: 'es-ES',
            height: 500,
            fontNames: ['Arial', 'Nunito', 'Roboto', 'Lato'],
            fontNamesIgnoreCheck: ['Lato', 'Roboto'],
            styleTags: [
              {
                title: 'Titulo Principal',
                tag: 'h1',
                value: 'h1',
                className: 'titulo_principal',
              },
              {
                title: 'Titulo Secundario',
                tag: 'h2',
                value: 'h2',
                className: 'titulo_secundario',
              },
              {
                title: 'Subtitulo',
                tag: 'h3',
                value: 'h3',
                className: 'subtitulo',
              },
              { title: 'Texto', tag: 'p', value: 'p', className: 'texto' },
              {
                title: 'texto_bold',
                tag: 'span',
                value: 'span',
                className: 'texto_bold',
              },
              {
                title: 'Texto Destacado',
                tag: 'p',
                value: 'p',
                className: 'destacado',
              },
              { title: 'Links', tag: 'a', value: 'a', className: 'links' },
            ],
          });
          textOriginal = $('.click2edit').summernote('code');
          console.log(textOriginal);
          $('.click2edit').summernote('fullscreen.toggle');
          $('.click2edit').summernote('fullscreen.toggle');
          $('#edit').html('<i class="fas fa-times"></i> Cancelar');
          $('#edit').attr('tipo', 'cancelar');
          $('#edit').removeClass('btn-primary').addClass('btn-danger');
        } else {
          console.log(textOriginal);
          $('.click2edit').summernote('code', textOriginal);
          $('#edit').html('<i class="far fa-edit"></i> Editar');
          $('#edit').attr('tipo', 'editar');
          $('#edit').removeClass('btn-danger').addClass('btn-primary');
          $('.click2edit').summernote('destroy');
          $('#edit').blur();
        }
      });
    });
  }

  ngOnInit(): void {
    this.loading = true;
    this.crearFormularioHash();
    this.isAdmin = this.tokenService.hasRole('Help_Admin');
    this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor');

    this.actRouter.params.subscribe((params) => {
      this.id = params['id'];
    });
    if (sessionStorage.getItem('pagina')) {
      this.paginaBuscador = Number(sessionStorage.getItem('pagina'));
      sessionStorage.setItem('pagina', '1');
    }

    this.preguntaService.getPrivacidadPregunta(this.id).subscribe((resp) => {
      if (resp !== null) {
        let publica = Boolean(resp);
        let peticion;
        if (publica === true) {
          peticion = this.preguntaService.getPreguntaRespuestaPublic(this.id);
        } else {
          peticion = this.preguntaService.getPreguntaRespuesta(this.id);
          sessionStorage.setItem('privado', 'SI');
          let sesionIniciada = this.tokenService.verificaUsuario();
          if (!sesionIniciada) {
            this.authService.loginRedirect();
            this.pregunta = null;
          }
        }
        peticion.subscribe(
          (resp) => {
            if (resp !== null) {
              this.pregunta = resp;
              this.html = this.domS.bypassSecurityTrustHtml(
                this.pregunta.respuesta
              );

              this.burbujaId = this.pregunta.burbujaId;
              sessionStorage.setItem('burbujaId', this.pregunta.burbujaId);
              sessionStorage.setItem('respuestaId', this.pregunta.respuestaId);
              sessionStorage.setItem('enunciado', this.pregunta.desPregunta);

              if (this.pregunta.hashtag != null) {
                if (this.pregunta.hashtag.slice(-1) == '#') {
                  this.pregunta.hashtag = this.pregunta.hashtag.substring(
                    0,
                    this.pregunta.hashtag.length - 1
                  );
                }
                this.formuHash.reset({
                  hashtag: this.pregunta.hashtag,
                });
                let hashs = this.pregunta.hashtag.split('#');
                hashs.forEach((element) => {
                  let hash: string = element.trim();
                  if (hash.length >= 1) {
                    hash = `<a href="/help/buscar/${hash}">#${hash}</a> `;
                    this.hashtags += hash;
                  }
                });
              }
              if (this.pregunta.respuesta == null) {
                this.pregunta.respuesta = 'Sin Respuesta';
                this.respuestaId = 0;
              } else {
                this.respuestaId = this.pregunta.respuestaId;
              }
            }
            let haySesion = this.tokenService.verificaUsuario();
            if (haySesion) {
              this.muestraFeed = true;
            } else {
              this.muestraFeed = false;
            }
            this.loading = false;
          },
          (error) => {
            console.error(error);
            this.loading = false;
          }
        );
      }
    });

    this.isAdmin = this.tokenService.hasRole('Help_Admin');
    this.isContribuidor = this.tokenService.hasRole('Help_Contribuidor');
  }

  get hashtagNoValido() {
    this.textoHashInvalido = '';
    if (this.formuHash.get('hashtag').touched) {
      let tieneNumeral: boolean = false;
      let hash: string = this.formuHash.get('hashtag').value.toString();
      if (hash.length >= 1 && hash.indexOf('#') == -1) {
        tieneNumeral = false;
        this.textoHashInvalido = 'El hashtag debe contener al menos un #';
        return true;
      } else {
        if (this.formuHash.get('hashtag').invalid) {
          this.textoHashInvalido = 'Por favor ingresa el hashtag';
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  get hashtagIncorrecto() {
    return (
      this.formuHash.get('hashtag').invalid &&
      this.formuHash.get('hashtag').touched
    );
  }

  gotoTemas(burbujaId: number, burbuja: string) {
    sessionStorage.setItem('burbujaDesc', burbuja);
    sessionStorage.setItem('pagina', this.paginaBuscador.toString());
    this.ruta = 'help/temas/' + burbujaId;
    this.router.navigateByUrl(this.ruta);
  }

  gotoPreguntas(temaId: number) {
    sessionStorage.setItem('pagina', this.paginaBuscador.toString());
    this.ruta = 'help/preguntas/' + temaId;
    this.router.navigateByUrl(this.ruta);
  }

  volver() {
    sessionStorage.setItem('pagina', this.paginaBuscador.toString());
    sessionStorage.setItem('origen', 'respuesta');
    this.router.navigateByUrl(sessionStorage.getItem('returnPreguntas'));
  }

  habilitarGuardar(buttomedit) {
    if (buttomedit.textContent == ' Editar') {
      this.editar = true;
    } else {
      this.editar = false;
    }
  }

  saveRespuesta(buttomSave) {
    this.crearFormulario();
    this.loading = true;

    buttomSave.disabled = true;
    buttomSave.textContent = 'Guardando...';
    this.preguntaService
      .guardarRespuesta(this.respForm.getRawValue())
      .subscribe({
        next: (data) => {
          this.loading = false;
          this.editar = false;
          buttomSave.disabled = true;
          buttomSave.textContent = 'Guardar';
          buttomSave.style.cursor = 'default';
          $('#edit').html('<i class="far fa-edit"></i> Editar');
          $('#edit').attr('tipo', 'editar');
          $('#edit').removeClass('btn-danger').addClass('btn-primary');
          $('.click2edit').summernote('destroy');
          let timerInterval;
          Swal.fire({
            //  title: 'Se Grabaron los cambios',
            text: `Respuesta guardada correctamente.`,
            icon: 'success',
            timer: 1500,
            timerProgressBar: true,
            willClose: () => {
              clearInterval(timerInterval);
            },
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector('b');
              timerInterval = setInterval(() => {
                if (b) {
                  b.textContent = Swal.getTimerLeft()?.toString();
                }
              }, 100);
            },
          });
        },
        error: (error) => {
          this.loading = false;
          let textoError = 'Ocurrió un error por favor intentarlo mas tarde.';
          if (
            error.error.errors.Textorta[0] ==
            'El campo Textorta es demasiado largo.'
          ) {
            textoError =
              'La repuesta que deseea guardar puede contener imagenes con tamaño muy grande por favor intente comprimir las mismas.';
          }
          Swal.fire({
            title: 'No se pudo guardar la respuesta',
            text: textoError,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        },
      });
  }

  crearFormulario() {
    var objList = $('.click2edit').summernote('code');
    this.respForm = this.fb.group({
      Textorta: [objList],
      preguntaId: [this.id],
    });
  }

  crearFormularioPublico(EsPublico: string) {
    this.respFormPub = this.fb.group({
      EsPublico: [EsPublico],
      preguntaId: [this.id],
    });
  }

  crearFormularioHash() {
    this.formuHash = this.fbHash.group({
      hashtag: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(300),
        ],
      ],
    });
  }

  verEditarHash() {
    this.editarHash = true;
    this.verBtnEditarHash = false;
    this.tempoHastag = this.formuHash.get('hashtag').value.toString().trim();
  }

  cancelEditarHash() {
    this.editarHash = false;
    this.verBtnEditarHash = true;
    this.formuHash.reset({
      hashtag: this.tempoHastag,
    });
  }

  guardarHash() {
    //validación de que el form sea valido
    if (this.formuHash.invalid) {
      return Object.values(this.formuHash.controls).forEach((control) => {
        if (control instanceof FormGroup) {
          Object.values(control.controls).forEach((control) =>
            control.markAsTouched()
          );
        } else {
          control.markAsTouched();
        }
      });
    }

    Swal.fire({
      title: 'Guardar Hashtag',
      html: '¿Confirmas la grabación del hashtag que editaste?',
      showDenyButton: true,
      confirmButtonText: `Si`,
      denyButtonText: `No`,
      icon: 'question',
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: 'Espera por favor',
          text: 'Guardando la información',
          allowOutsideClick: false,
          timerProgressBar: true,
        });
        Swal.showLoading();
        let timerInterval;
        let peticion: Observable<any>;
        peticion = this.elementoService.modificarHashtag(
          this.pregunta.elementoBusquedaId,
          this.pregunta.preguntaId,
          this.formuHash.get('hashtag').value
        );
        peticion.subscribe({
          next: (resp) => {
            Swal.fire({
              title: 'Hashtag modificado',
              text: 'El hashtag ha sido modificado correctamente',
              icon: 'success',
              timer: 1500,
              timerProgressBar: true,
              willClose: () => {
                clearInterval(timerInterval);
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.ruta = 'help/respuesta/' + this.pregunta.preguntaId;
                this.router.navigateByUrl(this.ruta);
              },
              didOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer().querySelector('b');
                timerInterval = setInterval(() => {
                  if (b) {
                    b.textContent = Swal.getTimerLeft()?.toString();
                  }
                }, 100);
              },
            }).then((resp) => {
              if (resp.isConfirmed) {
                this.router.routeReuseStrategy.shouldReuseRoute = () => false;
                this.router.onSameUrlNavigation = 'reload';
                this.ruta = 'help/respuesta/' + this.pregunta.preguntaId;
                this.router.navigateByUrl(this.ruta);
              }
            });
          },
          error: (error) => {
            console.error(error.error);
            Swal.fire({
              title: 'No se pudo actualizar el hashtag',
              text: `Ocurrió un error al intentar actualizar en la base de datos el hashtag`,
              icon: 'error',
              confirmButtonText: 'Ok',
            });
          },
        });
      }
    });
  }

  esPublico(check) {
    let timerInterval;
    this.crearFormularioPublico(check.currentTarget.checked);
    let TextoValor: string = check.currentTarget.checked
      ? 'Pública'
      : 'Privada';
    this.preguntaService
      .GuardarPublico(this.respFormPub.getRawValue())
      .subscribe({
        next: (data) => {
          Swal.fire({
            title: 'Se Grabaron los cambios',
            text: `La respuesta ahora es: ${TextoValor}.`,
            icon: 'success',
            timer: 1500,
            timerProgressBar: true,
            willClose: () => {
              clearInterval(timerInterval);
            },
            didOpen: () => {
              Swal.showLoading();
              const b = Swal.getHtmlContainer().querySelector('b');
              timerInterval = setInterval(() => {
                if (b) {
                  b.textContent = Swal.getTimerLeft()?.toString();
                }
              }, 100);
            },
          });
        },
        error: (error) => {
          console.error(error.error);
          Swal.fire({
            title: 'No se pudo guardar los cambios',
            text: `Ocurrió un error por favor intentarlo mas tarde.`,
            icon: 'error',
            confirmButtonText: 'Ok',
          });
        },
      });
  }
}
